import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { withLang } from "./withLang";

export const seasonsApi = createApi({
  reducerPath: "seasonsApi",
  baseQuery: withLang(
    fetchBaseQuery({
      baseUrl: `${process.env.REACT_APP_API_BASE_URL}/`,
    }),
  ),
  endpoints: (builder) => ({
    getPlayerSeasonInfo: builder.mutation({
      query: (body) => ({
        url: `/connect/v2/get-public-season-info`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const {
    useGetPlayerSeasonInfoMutation
} = seasonsApi;
